import React, { forwardRef } from 'react';
import InputTemplate from '../TemplateNumberFormatInput'

const TelefoneInput = forwardRef((props, ref) => (
    <InputTemplate {...props} formato="(##) #####-####" ref={ref} />
));

export default TelefoneInput